<template>
  <div
    v-if="data"
    class="basic_wrap"
    style="padding-bottom: 60px;"
  >
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div
        class="big_tit"
        style="font-size: 14px;"
      >
        {{ data.name }}
      </div>
      <div class="top_right" />
    </div>
    <div class="feiziInfo">
      <div class="topInfo">
        <div><span>{{ data.name }}</span></div>
        <div style="line-height: 25px;">
          <span style="margin-right: 20px;">{{ $t('sky.height') }}:{{ data.height }}cm  </span>
          <span>{{ $t('sky.high') }}：{{ data.xiong }}</span>
        </div>
        <div>
          <span
            v-if="data.keys[0]"
            class="van-tag  van-tag--primary"
          >{{ data.keys[0] }}</span>
          <span
            v-if="data.keys[1]"
            class="van-tag  van-tag--success"
          >{{ data.keys[1] }}</span>
          <span
            v-if="data.keys[2]"
            class="van-tag  van-tag--danger"
          >{{ data.keys[2] }}</span>
          <span
            v-if="data.keys[3]"
            class="van-tag  van-tag--warning"
          >{{ data.keys[3] }}</span>
        </div>
        <div>
          <span style="color: rgb(107, 34, 179); font-size: 14px;line-height: 25px;">
            {{ $t('sky.fee') }}：
          </span>
          <div
            tabindex="0"
            role="radiogroup"
            class="van-rate van-rate--readonly"
          >
            <div
              role="radio"
              tabindex="0"
              aria-setsize="5"
              aria-posinset="1"
              aria-checked="true"
              class="van-rate__item"
            >
              <i
                data-score="1"
                class="van-icon van-icon-star van-rate__icon van-rate__icon--full"
                style="color: rgb(242, 178, 71); font-size: 15px;"
              />
            </div>
            <div
              role="radio"
              tabindex="0"
              aria-setsize="5"
              aria-posinset="2"
              aria-checked="true"
              class="van-rate__item"
            >
              <i
                data-score="2"
                class="van-icon van-icon-star van-rate__icon van-rate__icon--full"
                style="color: rgb(242, 178, 71); font-size: 15px;"
              />
            </div>
            <div
              role="radio"
              tabindex="0"
              aria-setsize="5"
              aria-posinset="3"
              aria-checked="true"
              class="van-rate__item"
            >
              <i
                data-score="3"
                class="van-icon van-icon-star van-rate__icon van-rate__icon--full"
                style="color: rgb(242, 178, 71); font-size: 15px;"
              />
            </div>
            <div
              role="radio"
              tabindex="0"
              aria-setsize="5"
              aria-posinset="4"
              aria-checked="true"
              class="van-rate__item"
            >
              <i
                data-score="4"
                class="van-icon van-icon-star van-rate__icon van-rate__icon--full"
                style="color: rgb(242, 178, 71); font-size: 15px;"
              />
            </div>
            <div
              role="radio"
              tabindex="0"
              aria-setsize="5"
              aria-posinset="5"
              aria-checked="true"
              class="van-rate__item"
            >
              <i
                data-score="5"
                class="van-icon van-icon-star van-rate__icon van-rate__icon--full"
                style="color: rgb(242, 178, 71); font-size: 15px;"
              />
            </div>
          </div>
        </div>
        <div style="color: rgb(107, 34, 179); font-size: 14px; margin: 4px 0px;line-height: 25px;">
          {{ $t('sky.addr') }}：{{ data.addr }}
        </div>
        <div
          class="yuyueBox"
          @click="yuyue()"
        >
          {{ $t('sky.yuenow') }}
        </div>
        <div
          class="dianzanimg"
          @click="dianzan()"
        >
          <div
            class="van-image"
            style="width: 60px; height: 60px;"
          >
            <img
              src="../images/home/zan.png"
              class="van-image__img"
              style="object-fit: cover;"
            >
          </div>
          <p style="color: #6b22b3; margin: 0px;font-size: 14px;">
            {{ data.zan }}
          </p>
        </div>
      </div>
      <div class="cenInfo">
        <!-- <div >
		            <div  class="van-tabs van-tabs--line">
		                <div class="van-tabs__wrap">
							<div class="head-tabs">
							    <span @click="cur=0;" class="tab-item " :class="cur==0?'active':''">
								{{$t('sky.pic')}}
								</span>
								<span @click="cur=1;" class="tab-item " :class="cur==1?'active':''">
								{{$t('sky.profile')}}
								</span>
							</div>
		                </div>
		                <div class="van-tabs__content"></div>
		            </div>
		        </div> -->
        <div v-if="cur==0">
          <!--     <div  class="imgswiper">
		                <div  style="width: 100px; height: 100px; margin-right: 10px;">
		                    <div  class="imgI van-image" style="width: 100px; height: 100px;">
								<img :src="data.pic" class="van-image__img" style="object-fit: cover;"></div>
		                </div>
		            </div> -->
          <div
            v-if="imgs"
            class="van-image"
            style="width: 100%; height: 635px;"
          >
            <img
              v-if="imgs[0]"
              :src="'https://imgs.cnaphl.com'+imgs[0]"
              class="van-image__img"
              style="object-fit: cover;"
            >
            <img
              v-if="imgs[1]"
              :src="'https://imgs.cnaphl.com'+imgs[1]"
              class="van-image__img"
              style="object-fit: cover;"
            >
            <img
              v-if="imgs[2]"
              :src="'https://imgs.cnaphl.com'+imgs[2]"
              class="van-image__img"
              style="object-fit: cover;"
            >
            <img
              v-if="imgs[3]"
              :src="'https://imgs.cnaphl.com'+imgs[3]"
              class="van-image__img"
              style="object-fit: cover;"
            >
            <img
              v-if="imgs[4]"
              :src="'https://imgs.cnaphl.com'+imgs[4]"
              class="van-image__img"
              style="object-fit: cover;"
            >
          </div>
          <div
            v-else
            class="van-image"
            style="width: 100%; height: 635px;"
          >
            <img
              v-if="data.pic"
              :src="data.pic"
              class="van-image__img"
              style="object-fit: cover;"
            >
          </div>
        </div>
        <div style="padding-top: 20px; display: none;" />
      </div>

      <div
        v-if="cur==1"
        class="btmInfo"
      >
        <!--    <div  style="color: rgb(42, 20, 104); margin-bottom: 10px; font-weight: bold;">
				{{$t('sky.profile')}}
				</div> -->
        <div style="color: rgb(83, 69, 137);">
          {{ data.desc }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty,List,Card,ShareSheet 
	} from "vant";
    var _that;
	import Fetch from "../../utils/fetch";
	Vue.use(Empty).use(List).use(Card).use(ShareSheet);
	export default {
		name: "Vprofile",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data: null,
				loading:false,
				yizan:false,
				page:1,
				list:null,
				cur:0,
				imgs:null,
				area:null,
				arealist:null,
				locationsel: false,
				type:0,
				finished:false,
				empty: false,
			};
		},
		created() {
			this.$parent.footer("girl",true);
		},
		mounted() {
			this.start();
			_that = this;
		},
		methods: {
			yuyue(){
				this.$toast(this.$t('sky.jihuo'));
			},
			dianzan(){
				if(this.yizan){
					this.data.zan = this.data.zan-1;
					this.yizan = false;
				}else{
					this.data.zan = this.data.zan+1;
					this.yizan = true;
				}
			},
			start() {
				Fetch('/index/girl', {
					id: this.$router.history.current.params.code
				}).then(res => {
					this.data = res.data.girl;
					this.data.keys = this.data.keystr.split('|');
					this.imgs = this.data.imgs.split('|');
				})
			}
		},
	};
</script>

<style lang="less" scoped>
	
.feiziInfo {
background: #ebedf0
}

.feiziInfo>div {
padding: 16px 20px;
background: #fff;
margin-bottom: 16px
}

.feiziInfo .topInfo {
position: relative
}

.feiziInfo .topInfo>div:first-child {
font-weight: 600
}

.feiziInfo .topInfo>div:first-child>span:first-child {
color: #2c1868;
font-size: 20px
}

.feiziInfo .topInfo>div:first-child>span:nth-child(2) {
color: #f2b247;
font-size: 20px
}

.feiziInfo .topInfo>div:nth-child(2) {
color: #6b22b3;
font-size: 12px;
margin: 10px 0
}

.feiziInfo .topInfo>div:nth-child(3) {
width: 50%
}

.feiziInfo .topInfo>div:nth-child(3)>div {
background: linear-gradient(50deg,#9b54ca,#e6557f);
color: #fff;
display: inline-block;
border-radius: 10px;
margin-right: 15px;
font-size: 12px;
padding: 8px;
margin-bottom: 15px
}

.feiziInfo .topInfo>div:nth-child(3)>div:nth-child(5) {
margin-right: 16vw
}

.feiziInfo .topInfo .yuyueBox {
position: absolute;
right: 16px;
bottom: 20px;
color: #fff;
padding: 10px 15px;
background: linear-gradient(20deg,#e73266,#ee5380);
border-radius: 7vw
}

.feiziInfo .topInfo .dianzanimg {
position: absolute;
top: 16px;
right: 7vw;
text-align: center
}

.feiziInfo .cenInfo .van-tab__text {
font-size: 18px
}

.feiziInfo .cenInfo .imgswiper {
width: 100%;
overflow-x: scroll;
margin: 16px 0;
display: flex;
flex-wrap: nowrap
}

.feiziInfo .cenInfo .imgswiper>div .imgI.active {
border: 5px solid #e54878
}
/deep/ .van-tag{
	margin: 5px 5px 5px 0;
}
.feiziInfo .topInfo > div[data-v-508625eb]:nth-child(2){
	line-height: 25px;
	margin: 5px 0;
}
.head-tabs{
	padding-left: 0px;
	padding-top: 5px;
	text-align: left;
}
// .feiziInfo > div{
// 	padding-top: 0px;
// }
</style>
